import { Locations, Points } from "../setup-implement.model";


export class ImplementToCopy {
    selectImplement: boolean;
    implementId: number;
    implementTypeAndSerial: string;
    newSerialNo: string;
    setupDate: string;
    implementHoursAtSetup: number;
    equipmentSMUAtSetup: number;
    status: number;
    budget_hours:number;
    Purchased_Cost:number;
}

export class ListOfComponetInfo{
    public implementId :number;
    public ImpSerial :string;

    public componnetList: CopyComponentListVM[]
}

export class CopyComponentListVM{
    public ComponentId:number;
    public ComponentName :string;
    public ComponentTypeId :number;
    public ComponentTypeName:string;
    public PartNo:string;
    public Make:string;
    public BudgetLife:number;
    public SelectedComp:boolean;
    public SortOrder:number;
    public expanded:boolean=false;
    public DisableCheckbox: boolean=false;
  public ObsList: CopyObservationListVM[];
  public IdentifiedCompName: string;
  public CompLocations: string[];
}

export class CopyObservationListVM{
    public ObsId:number;
    public ObsName:string;
    public ObsTypeId:number;
    public ObsType:string;
    public CompId:number;
    public SelectedObs:boolean=true;
    public DisableCheckbox: boolean=false;
}

export class CopyImplmentVM{
    public SourcesImplementId:number;
    public ExistingImplementId:number;
    public equipmentId:number;
    public jobsiteId:number;
    public newImplementSerialNo:string;
    public setupDate:string;
    public implementHoursAtSetup:number;
    public equipmentSMUAtSetup:number;
    public hours:number;
    public cost:number;
    public selectedcomponentList:CopyComponentListVM[];
    public selectedImplemetID:number;
    public isCopyToTemplate:boolean;
    public selectedImpTypeId:number;
    public isCopyTemplateToTemplate:boolean;
    public IsSchematicUsedLink:boolean;

}
